/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `create:comment` - CREATE:COMMENT * `create:invitation` - CREATE:INVITATION * `create:issue` - CREATE:ISSUE * `create:job` - CREATE:JOB * `create:membership` - CREATE:MEMBERSHIP * `create:project` - CREATE:PROJECT * `create:task` - CREATE:TASK * `delete:comment` - DELETE:COMMENT * `delete:invitation` - DELETE:INVITATION * `delete:issue` - DELETE:ISSUE * `delete:job` - DELETE:JOB * `delete:membership` - DELETE:MEMBERSHIP * `delete:organization` - DELETE:ORGANIZATION * `delete:project` - DELETE:PROJECT * `delete:task` - DELETE:TASK * `update:comment` - UPDATE:COMMENT * `update:issue` - UPDATE:ISSUE * `update:job` - UPDATE:JOB * `update:membership` - UPDATE:MEMBERSHIP * `update:organization` - UPDATE:ORGANIZATION * `update:project` - UPDATE:PROJECT * `update:task` - UPDATE:TASK
 * @export
 * @enum {string}
 */

export const EventsEnum = {
    CreateComment: 'create:comment',
    CreateInvitation: 'create:invitation',
    CreateIssue: 'create:issue',
    CreateJob: 'create:job',
    CreateMembership: 'create:membership',
    CreateProject: 'create:project',
    CreateTask: 'create:task',
    DeleteComment: 'delete:comment',
    DeleteInvitation: 'delete:invitation',
    DeleteIssue: 'delete:issue',
    DeleteJob: 'delete:job',
    DeleteMembership: 'delete:membership',
    DeleteOrganization: 'delete:organization',
    DeleteProject: 'delete:project',
    DeleteTask: 'delete:task',
    UpdateComment: 'update:comment',
    UpdateIssue: 'update:issue',
    UpdateJob: 'update:job',
    UpdateMembership: 'update:membership',
    UpdateOrganization: 'update:organization',
    UpdateProject: 'update:project',
    UpdateTask: 'update:task'
} as const;

export type EventsEnum = typeof EventsEnum[keyof typeof EventsEnum];



